
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"12","height":"12"}},[_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 0h12v12H0z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"fill":"#FFF","fill-rule":"nonzero","d":"M10.775 2.293a.783.783 0 0 1 1.058 1.153L5.007 9.707a.783.783 0 0 1-1.136-.082L.263 5.201a.783.783 0 0 1 1.213-.99L4.56 7.994l6.215-5.7z","mask":"url(#b)"}})])])
      }
    
      }
    